module.exports = __webpack_public_path__ + "assets/img/center_icon07.20fd65d5.svg";